module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fsaVo"))).then(() => parcelRequire('f4eak'));